module.exports = __webpack_public_path__ + "static/media/ic-package.be8fbeaf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-package.svg
// module id = 651
// module chunks = 14